<template>
  <div class="result-wrap">
    <!--遮罩层-->
    <div class="left-title">
      <div>
        <img src="../../../assets/img/grammarTest/book.png" alt />
        <p>语法复习中</p>
      </div>
    </div>
    <div class="content-box">
      <!--强制复习时的提示-->
      <transition name="el-fade-in-linear" mode="out-in">
        <div class="result-box" key="1">
          <div class="left-box">
            <div class="test-info">
              <img src="../../../assets/img/grammarTest/dot.png" alt />
              <span>语法总数（个）：</span>
              <span>{{ reportData.total }}</span>
            </div>
            <div class="test-info">
              <img src="../../../assets/img/grammarTest/dot.png" alt />
              <span>未完成数（个）：</span>
              <span class="bad-test">{{ reportData.uncomplete_num }}</span>
            </div>
            <div class="test-info">
              <img src="../../../assets/img/grammarTest/dot.png" alt />
              <span>本次学习（个）：</span>
              <span>{{ reportData.cur_num }}</span>
            </div>
            <div class="test-info">
              <img src="../../../assets/img/grammarTest/dot.png" alt />
              <span>继续学习可获得更多能量石</span>
            </div>
          </div>
          <div class="right-box">
            <div class="img-icon">
              <img src="../../../assets/img/grammarTest/treasure_box.png" alt />
              <div>本次复习将收获{{ reportData.point || 0 }}能量石</div>
            </div>
            <div class="right-btn">
              <el-button type="primary" @click="keepStudy">继续学习</el-button>
              <el-button type="danger" @click="saveQuit">保存退出</el-button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import Lockr from "lockr";
import {
  saveQuit,
  yfSaveQuit,
  yfBreakQuit,
  breakQuit,
  AIbreakQuit,
  ZNbreakQuit,
  preciseBreakQuit,
  emptyOnceStudyNum,
} from "@/api/grammar";

export default {
  name: "spell",
  props: {
    ShowSpellPop: {},
    dataType: {
      type: String,
      default: "default",
    },
    dataSource: {},
  },

  data() {
    return {
      showResult: false, //显示结果
      reportData: {
        total: "",
        uncomplete_num: "",
        cur_num: "",
      },
    };
  },
  computed: {
    ...mapGetters(["studyStage"]),
  },
  methods: {
    // 获取学习数据
    async getQuitInfo() {
      if (this.studyStage.courseType == "yfxx") {
        let params = {
          token: Lockr.get("token"),
          student_id: this.dataSource.student_id,
          cur_group: this.dataSource.cur_group,
          unit_id: this.dataSource.unit_id,
        };
        let result = await yfBreakQuit(params);
        if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
          this.reportData = result.data;
        } else {
          this.$message({
            message: result.msg,
            type: "warning",
          });
        }
      } else if (this.studyStage.courseType == "znfx") {
        //智能复习
        let params = {
          token: Lockr.get("token"),
          count: this.studyStage.dataSource.count,
          type: 5,
        };
        let result = await AIbreakQuit(params);
        if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
          this.reportData = result.data;
          this.reportData.total = result.data.count;
          this.reportData.uncomplete_num = result.data.un_complete;
          this.reportData.cur_num = result.data.complete;
          this.reportData.point = result.data.power;
        } else {
          this.$message({
            message: result.msg,
            type: "warning",
          });
        }
      } else if (this.studyStage.courseType == "jzfx") {
        //精准复习
        let params = {
          token: Lockr.get("token"),
          count: this.studyStage.dataSource.count,
          type: 4,
        };
        let result = await preciseBreakQuit(params);
        if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
          this.reportData = result.data;
          this.reportData.total = result.data.count;
          this.reportData.uncomplete_num = result.data.un_complete;
          this.reportData.cur_num = result.data.complete;
          this.reportData.point = result.data.power;
        } else {
          this.$message({
            message: result.msg,
            type: "warning",
          });
        }
      } else if (this.studyStage.courseType == "zntx") {
        //智能听写
        let params = {
          token: Lockr.get("token"),
          count: this.studyStage.dataSource.count,
          type: 3,
        };
        let result = await ZNbreakQuit(params);
        if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
          this.reportData = result.data;
          this.reportData.total = result.data.count;
          this.reportData.uncomplete_num = result.data.un_complete;
          this.reportData.cur_num = result.data.complete;
          this.reportData.point = result.data.power;
        } else {
          this.$message({
            message: result.msg,
            type: "warning",
          });
        }
      } else if (
        this.studyStage.courseType == "yfctb" ||
        this.studyStage.courseType == "dyctb"
      ) {
        let params = {
          token: Lockr.get("token"),
          student_id: this.dataSource.student_id,
          unit_id: this.dataSource.unit_id,
          unit_complet: 1,
          sign: "",
        };
        if (this.studyStage.courseType == "yfctb") params.sign = 6;
        if (this.studyStage.courseType == "dyctb") params.sign = 7;
        let result = await breakQuit(params);
        if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
          this.reportData = result.data;
        } else {
          this.$message({
            message: result.msg,
            type: "warning",
          });
        }
      }
    },
    //继续学习
    keepStudy() {
      this.$emit("keepStudy");
    },
    //保存退出
    saveQuit() {
      let params = {
        token: Lockr.get("token"),
      };
      emptyOnceStudyNum(params);
      this.$emit("quit");
    },
  },
  created() {
    this.getQuitInfo();
  },
};
</script>

<style scoped lang='less'>
.result-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .left-title {
    padding: 10px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > div:nth-of-type(1) {
      display: flex;
      align-items: center;

      p {
        font-size: 18px;
      }

      img {
        display: block;
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }

    .countDown {
      background: url("../../../assets/img/grammarTest/time_bg.png");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      width: 50px;
      height: 50px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .content-box {
    flex: 1;
    transition: all 0.5s;
    position: relative;
    display: flex;
    align-items: center;

    .hint-text {
      flex: 1;
      position: relative;
      text-align: center;
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      > .hint-box {
        padding: 60px 180px;
        box-shadow: 0px 1px 12px 3px rgba(0, 0, 0, 0.08);
      }

      > div:nth-of-type(2) {
        color: #ff626f;
        margin: 5px 0;
      }
    }

    .exercise-box {
      padding-top: 15px;
      padding-left: 80px;

      .statement-text {
        font-size: 30px;
        font-weight: 600;
        display: flex;
        align-items: center;
        margin: 20px 0;
        padding-right: 40px;

        > .volume {
          margin-left: 5px;
          cursor: pointer;
          height: 33px;

          img {
            width: 35px;
          }

          img:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }

  /*语法相关*/

  .result-box {
    display: flex;
    width: 100%;
    .left-box,
    .right-box {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 22px;
      font-weight: 600;

      .test-info {
        width: 330px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 10px 0;
        padding: 16px 0 16px 20px;
        box-shadow: 0px 1px 12px 3px rgba(0, 0, 0, 0.08);

        img {
          width: 30px;
          margin-right: 10px;
        }

        .bad-test {
          color: #f56c6c;
        }
      }
    }

    .right-box {
      .right-btn {
        margin-top: 30px;
      }

      .img-icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
          margin-bottom: 10px;
          width: 70px;
        }
      }
    }
  }
}
</style>